import ColorSelector from './code/Scripts/components/ColorSelector.vue';

export default {
  components: {
    ColorSelector,
  },
};
